import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useUniqueID } from "@xo-union/react-unique-id";
import { LayoutRoot, MainContentLabelProvider } from "@xo-union/ui-accessibility";
import { ContainerWithStickyColumn } from "@xo-union/tk-component-grid";
import { SnackbarProvider } from "@xo-union/tk-component-alerts";
import SkipToContent from "./SkipToContent.js";
const Layout = _ref => {
  let {
    header,
    leftNav,
    footer,
    masthead,
    children,
    mainContentId,
    mastheadTitleId,
    ...rest
  } = _ref;
  const finalMastheadTitleID = useUniqueID(mastheadTitleId);
  const mainSection = leftNav ? /*#__PURE__*/React.createElement(ContainerWithStickyColumn, _extends({
    as: "main",
    id: mainContentId,
    stickyColumnContent: leftNav,
    mainContent: children
  }, rest)) : /*#__PURE__*/React.createElement(MainContentLabelProvider, {
    id: finalMastheadTitleID
  }, /*#__PURE__*/React.createElement("main", _extends({
    id: mainContentId,
    "aria-labelledby": masthead && finalMastheadTitleID
  }, rest), masthead && /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": finalMastheadTitleID
  }, masthead), children));
  return /*#__PURE__*/React.createElement(LayoutRoot, null, /*#__PURE__*/React.createElement(SnackbarProvider, null, /*#__PURE__*/React.createElement(SkipToContent, {
    mainContentId: mainContentId
  }), header ? /*#__PURE__*/React.createElement("header", null, header) : undefined, mainSection, footer ? /*#__PURE__*/React.createElement("footer", null, footer) : undefined));
};
process.env.NODE_ENV !== "production" ? Layout.propTypes = {
  /**
   * The LeftNav component to render. If provided, will wrap main in a ContainerWithStickyColumn grid component.
   */
  leftNav: PropTypes.node,
  /**
   * The HeaderNav component to render (can include SubNav)
   */
  header: PropTypes.node,
  /**
   * The FooterNav component to render (can include CustomSection).
   */
  footer: PropTypes.node,
  /**
   * The Masthead component to render. If provided, it will be wrapped in a <section> and linked with <main> automatically.
   */
  masthead: PropTypes.node,
  /**
   * The content to will appear to the right of the LeftNav in a ContainerWithStickyColumn grid component. If leftNav is not provided, children are simply wrapped in a main tag, with no grid styling.
   */
  children: PropTypes.node,
  /**
   * Id of main content for accessibility "skip to main content" link. Will link to main content container by default but can be overridden.
   */
  mainContentId: PropTypes.string,
  /**
   * Id of masthead title for accessibility. If not provided it'll generate one automatically.
   */
  mastheadTitleId: PropTypes.string
} : void 0;
Layout.defaultProps = {
  mainContentId: 'union-layout-main'
};
export default Layout;